import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import netlifyIdentity from "netlify-identity-widget";

import "./index.css";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/scrollToTop";

netlifyIdentity.init();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
